import React from 'react';
import { ConfirmDialog } from 'primereact/confirmdialog';

function PrimeReactConfirmDialog(props) {
  const {
    isVisible = false,
    message = '',
    header = '',
    icon = '',
    className = '',
    onHideConfirmDialog = () => {},
    onAcceptConfirmDialog = () => {},
    OnRejectConfirmDialog = () => {},
    ...rest
  } = props;
  return (
    <ConfirmDialog
      visible={isVisible}
      onHide={() => onHideConfirmDialog()}
      message={message}
      header={header}
      icon={icon}
      className={className}
      accept={() => {
        onAcceptConfirmDialog();
      }}
      reject={() => {
        OnRejectConfirmDialog();
      }}
      {...rest}
    />
  );
}

export default PrimeReactConfirmDialog;
